module.exports = __webpack_public_path__ + "static/media/herdy-sitting-icecream.62a78de2.svg";